import { BaseChannel, ChannelType } from '@/realtime/channels/baseChannel';
// eslint-disable-next-line import/prefer-default-export
export class PresenceChannel extends BaseChannel {
    constructor(suffix) {
        super(ChannelType.PRESENCE);
        this.setSuffix(suffix);
    }
}
